var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inline-svg',{staticClass:"svg-icon",attrs:{"src":require(`@/assets/svg/${_vm.name}.svg`),"title":_vm.title,"aria-label":_vm.title},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }